var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-pagination',_vm._g(_vm._b({attrs:{"background":""}},'el-pagination',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }